import { $host } from ".";

// Get all special offers
export const fetchSpecialOffers = async () => {
    try {
        const { data } = await $host.get('api/special_offer');
        return data;
    } catch (error) {
        console.error("Error fetching special offers:", error);
        return error;
    }
};

// Get one special offer by ID
export const fetchSpecialOffer = async (id) => {
    try {
        const { data } = await $host.get('api/special_offer/id/' + id);
        return data;
    } catch (error) {
        console.error("Error fetching special offer:", error);
        return error;
    }
};

// Create a new special offer
export const createSpecialOffer = async (specialOffer) => {
    try {
        const { data } = await $host.post('api/special_offer', specialOffer);
        return data;
    } catch (error) {
        console.error("Error creating special offer:", error);
        return error;
    }
};

// Update a special offer
export const updateSpecialOffer = async (id, specialOffer) => {
    try {
        const { data } = await $host.put('api/special_offer/' + id, specialOffer);
        return data;
    } catch (error) {
        console.error("Error updating special offer:", error);
        return error;
    }
};

// Delete a special offer
export const deleteSpecialOffer = async (id) => {
    try {
        const { data } = await $host.delete('api/special_offer/' + id);
        return data;
    } catch (error) {
        console.error("Error deleting special offer:", error);
        return error;
    }
};
